import { PolluxGridConfig } from "../../../../../components/common/pollux-grid-config/pollux-grid-config";

export const valuationsGridColumns: PolluxGridConfig[] = [
  {
    field: "checkbox",
    type: "checkbox",
    width: 40
  },
  {
    title: 'comparablesValuation.PrimaryUse',
    field: "PrimaryUse",
    width: 200
  },
  {
    title: 'property.sector',
    field: "Sector",
    width: 200
  },
  {
    title: 'comparablesValuation.propertyName',
    field: "propertyName",
    width: 200
  },
  {
    title: 'comparablesValuation.city',
    field: "city",
    width: 200
  },
  {
    title: 'comparablesValuation.street',
    field: "street",
    width: 200
  },
  {
    title: 'comparablesValuation.numberFrom',
    field: "numberFrom",
    width: 200
  },
  {
    title: 'comparablesValuation.numberTo',
    field: "numberTo",
    width: 200
  },
  {
    title: 'comparablesValuation.numberAdd',
    field: "numberAdd",
    width: 200
  },
  {
    title: 'comparablesValuation.constructionYear',
    field: "constructionYear",
    width: 200,
    type: "year"
  },
  {
    title: 'comparablesValuation.renovationYear',
    field: "renovationYear",
    width: 200,
    type: "year"
  },
  {
    title: 'comparablesValuation.energyLabel',
    field: "EnergyLabelDescription",
    width: 200
  },
  {
    title: 'comparablesValuation.PercentEquity',
    field: "PercentEquity",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesValuation.TenureType',
    field: "TenureType",
    width: 200
  },
  {
    title: 'comparablesValuation.PropFileRefNo',
    field: "PropFileRefNo",
    width: 200
  },
  {
    title: 'comparablesValuation.EntityId',
    field: "EntityId",
    width: 200
  },
  {
    title: 'comparablesValuation.PreparerName',
    field: "PreparerName",
    width: 200
  },
  {
    title: 'comparablesValuation.PropertyIrr',
    field: "PropertyIrr",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesValuation.TotalArea',
    field: "TotalArea",
    type: 'area',
    width: 200
  },
  {
    title: 'comparablesValuation.GrossValue',
    field: "GrossValue",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesValuation.CapitalCosts',
    field: "CapitalCosts",
    type: 'currency',
    width: 200
  },
  {
    title: 'comparablesValuation.AcquisitionCosts',
    field: "AcquisitionCosts",
    type: 'currency',
    width: 200
  },
  {
    title: 'comparablesValuation.NetValue',
    field: "NetValue",
    type: 'currency',
    width: 200
  },
  {
    title: 'comparablesValuation.SayValue',
    field: "SayValue",
    type: 'currency',
    width: 200
  },
  {
    title: 'comparablesValuation.EquivalentYield',
    field: "EquivalentYield",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesValuation.TrueEquivalentYield',
    field: "TrueEquivalentYield",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesValuation.InitialYield',
    field: "InitialYield",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesValuation.ReversionaryYield',
    field: "ReversionaryYield",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesValuation.GrossRent',
    field: "GrossRent",
    type: 'currency',
    width: 200
  },
  {
    title: 'comparablesValuation.GrossRentalValue',
    field: "GrossRentalValue",
    type: 'currency',
    width: 200
  },
  {
    title: 'comparablesValuation.NetRent',
    field: "NetRent",
    type: 'currency',
    width: 200
  },
  {
    title: 'comparablesValuation.NoOfTenants',
    field: "NoOfTenants",
    type: 'number',
    width: 200
  },
  {
    title: 'comparablesValuation.CurrencyCode',
    field: "CurrencyCode",
    width: 200
  },
  {
    title: 'comparablesValuation.CurrencyDescription',
    field: "CurrencyDescription",
    width: 200
  },
  {
    title: 'comparablesValuation.commentOnValuation',
    field: "commentOnValuation",
    width: 200
  },
  {
    title: 'comparablesValuation.totalNumberOfParkingPlaces',
    field: "totalNumberOfParkingPlaces",
    type: 'number',
    width: 200
  },
  {
    title: 'comparablesValuation.numberOfInternalParkingPlaces',
    field: "numberOfInternalParkingPlaces",
    type: 'number',
    width: 200
  },
  {
    title: 'comparablesValuation.numberOfExternalParkingPlaces',
    field: "numberOfExternalParkingPlaces",
    type: 'number',
    width: 200
  },
  {
    title: 'comparablesValuation.nursingHomeTotal',
    field: "nursingHomeTotal",
    type: 'number',
    width: 200
  },
  {
    title: 'comparablesValuation.nursingHomeDoubleRooms',
    field: "nursingHomeDoubleRooms",
    type: 'number',
    width: 200
  },
  {
    title: 'comparablesValuation.nursingHomeSingleRooms',
    field: "nursingHomeSingleRooms",
    type: 'number',
    width: 200
  },
  {
    title: 'comparablesValuation.hotelNumberOfRooms',
    field: "hotelNumberOfRooms",
    type: 'number',
    width: 200
  },
  {
    title: 'comparablesValuation.residentialUnits',
    field: "residentialUnits",
    type: 'number',
    width: 200
  },
  {
    title: 'comparablesValuation.linkToProjectFolder',
    field: "linkToProjectFolder",
    width: 200
  },
  {
    title: 'comparablesValuation.importName',
    field: "importName",
    width: 200
  },
  {
    title: 'projectstd.currency',
    field: "currencyDescription",
    width: 200
  },
  {
    title: 'projectstd.unitOfLength',
    field: "unitOfLengthDescription",
    width: 200
  },
  {
    title: 'comparablesValuation.valuationId',
    field: "valuationIdDescription",
    width: 200
  },
  {
    title: 'comparablesValuation.projectPuid',
    field: "projectPuidDescription",
    width: 200
  },
  {
    title: 'comparablesValuation.propertyID',
    field: "propertyIDDescription",
    width: 200
  },
  {
    title: 'comparablesValuation.oID',
    field: "oid",
    width: 200
  },
  {
    title: 'comparablesValuation.modifiedAt',
    field: "modifiedAt",
    type: 'date',
    width: 200
  },
  {
    title: 'comparablesValuation.modifiedBy',
    field: "modifiedByDescription",
    width: 200
  },
  {
    title: 'comparablesValuation.createdAt',
    field: "createdAt",
    type: 'date',
    width: 200
  },
  {
    title: 'comparablesValuation.createdBy',
    field: "createdByDescription",
    width: 200
  }
];
